import { FC } from 'react';

import { FormLabel, InputBase, Stack } from '@mui/material';
import { useField } from 'formik';

interface TextAreaInput {
    name: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    minRows?: number;
    inputStyle?: object;
}

export const TextAreaInput: FC<TextAreaInput> = ({
    label,
    placeholder,
    name,
    disabled,
    minRows = 7,
    inputStyle,
}) => {
    const [field, meta] = useField(name);

    return (
        <Stack>
            {label && (
                <FormLabel sx={{ marginBottom: '8px', color: '#000', fontWeight: 600 }}>
                    {label}
                </FormLabel>
            )}
            <InputBase
                placeholder={placeholder}
                {...field}
                multiline
                {...inputStyle}
                minRows={minRows}
                className={`form-text-area ${meta.touched && meta.error ? 'input-error' : ''}`}
                disabled={disabled}
                inputProps={{ 'data-testid': `text-area-${name}` }}
            />
            {meta.touched && meta.error && <label className="error">{meta.error}</label>}
        </Stack>
    );
};
